'use client';

import { createContext } from 'react';

import type { ComboboxGroupContextInterface } from '../types/combobox-group.types';

export const ComboboxGroupContext = createContext<ComboboxGroupContextInterface>({});

ComboboxGroupContext.displayName = 'Combobox.Group.Context';
